import * as Sentry from '@sentry/react';
import type { User, UserWorkspace } from '@altsui/shared';

interface AuthSnapshot {
  user: User | null;
  activeFundId: string | null;
  workspaces: UserWorkspace[];
}

interface AuthSource {
  getState: () => AuthSnapshot;
  subscribe: (listener: (state: AuthSnapshot) => void) => () => void;
}

let tagged: string | null = null;

/** Inside a private demo copy every web error names the copy and the person; anywhere else neither is sent. */
export function syncDemoCopySentryTags(state: AuthSnapshot): void {
  const fundId = state.activeFundId ?? state.user?.fundId ?? null;
  const user = state.user;
  const inCopy = Boolean(user && fundId && state.workspaces.some((workspace) => workspace.fundId === fundId && workspace.demoCopy));
  const key = inCopy && user ? `${fundId}|${user.id}|${user.email}` : null;
  if (key === tagged) return;
  tagged = key;
  if (inCopy && user) {
    Sentry.setTag('demo_copy', fundId);
    Sentry.setTag('demo_person', user.email);
    Sentry.setUser({ id: user.id, email: user.email });
    return;
  }
  Sentry.setTag('demo_copy', undefined);
  Sentry.setTag('demo_person', undefined);
  Sentry.setUser(null);
}

/** Tags now and on every auth change; returns the unsubscribe. */
export function installDemoCopySentryTags(store: AuthSource): () => void {
  syncDemoCopySentryTags(store.getState());
  return store.subscribe(syncDemoCopySentryTags);
}
